import { RedirectRequest } from "@azure/msal-browser";

declare const window: any;
const OKTA_TESTING_DISABLEHTTPSCHECK = false;
const REDIRECT_URI = `${window.location.origin}`;
const clientId = `${window.extended?.IONIC_APP_CLIENT_ID}`;
const issuer = `${window.extended?.IONIC_APP_ISSUER}`;

// eslint-disable-next-line
export const msalConfig =   {
  auth: {
    authority: issuer, // Replace with your tenant ID
    clientId: clientId, // Replace with your client ID
    redirectUri: REDIRECT_URI,
    response_type: "code",
    scope: "openid profile email",
    post_logout_redirect_uri: REDIRECT_URI
  },
  resourceServer: {
    messagesUrl: 'http://localhost:3000/api/messages',
  },
  cache: {
    cacheLocation: "sessionStorage", // Configures browser storage for token caches
    storeAuthStateInCookie: false, // Set to true for better IE11/Edge support
  }
};

// export const loginRequest = {
//   scopes: ["User.Read"] // Optional scopes for API access
// };

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest: RedirectRequest = {
  scopes: ['User.Read'],
};